import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TestimonyCard from "./TestimonyCards";
import axiosInstance from "../../axiosinstance";

import "./Testimonials.css";
import { fadeIn, staggerContainer } from "../../utils/motion";
import { motion } from "framer-motion";
import ButtonThree from "../button/ButtonThree";
import TestimonyModal from "./modal/TestimonyModal";
import HorizontalScroller from "../HorizontalScroller/HorizontalScroller";
import HorizontalScroll from "../HorizontalScroll/HorizontalScroll";

// Loaded on first click so the homepage doesn't carry the testimony form

type TestimonyItem = { username: string; subtitle: string; desc: string };

// Shown after the published testimonies from the API
const staticTestimonials: TestimonyItem[] = [
  {
    username: "Grace Owusu Ampofo",
    subtitle: "Healing and Deliverance Testimony Through a word of Knowledge",
    desc: `Thank you Jesus. I am the woman whom the Lord has shown mercy. My name is Grace, testifying from Ghana. My name was mentioned on the 1st of November during the live stream when the servant of God, Chantal, was ministering about divine healing. And I believe I have received my freedom and my deliverance from every attack. I am here like the one leper to say thank you Jesus, thank you Jesus. I am free. I am healed. All the glory to you, God Most High.
God bless you, servant of God. More grace. May the oil on your head never run dry. God bless your ministry and your home.`,
  },

  {
    username: "Themba Nyirenda",
    subtitle: "Deliverance through a word of knowledge",
    desc: `Good day chantel, I'm Themba from Malawi. I am the one you were praying for yesterday and spoke "they took your soul, destiny, shot an arrow at your left chest and projected blindness" Thank you for your prayers. I connected to a Deceitful church and have now disconnected there. May the Lord continually bless you and those who concerns you in jesus mighty name.`,
  },

  {
    username: "L. Land",
    subtitle: "Restoration From Job Loss and Generational Battles",
    desc: `Greetings Minister Ekabe,
I have been a part of listening to your ministry since 2021. I have learned so much from your YouTube broadcasts of prayers and teachings, even as a seasoned Christian since my early 20s, and now I am 53 years old. My relationship with God and my prayer life have radically been transformed.
I wanted to give my testimony of what God has done to restore what I lost. I had been wrongfully fired from two jobs back to back within a 2-year time frame, which is not normal—especially when I know that I am a very good worker with a very good work ethic, and I have never been fired from a job before.
After experiencing much depression and broken confidence, I began to seek God, and I realized—by the help of the Holy Spirit revealing it—that I was suffering from a generational curse of rejection and compromise. I also found out that my grandmother had performed some kind of witchcraft ritual and manipulation.
These curses were not only causing ungodly rejection, but I wasn’t able to cross over the line of limitation, unable to advance past a certain point.
So, as I followed God’s instructions about becoming free of these curses through going to the Courts of Heaven, repenting, renouncing, and fasting, after 5 months (since May of 2025) of being unemployed, God opened a new door.
God restored my career with a significant pay increase that is more than what I was expecting.
So I return all the glory, all the praise, and all the honor to God for choosing to show mercy by answering my prayer for a new job. And I pray that I will excel and thrive in this new career opportunity and that it will be permanent in Jesus Christ’s Name.`,
  },

  {
    username: "Frankfame Enisire",
    subtitle:
      "Healing from a life threatening sickness, & Deliverance from accident",
    desc: `Good morning Ma, I want to testify to the glory of God. I thank God for delivering me from a sickness that was a threat to my life two weeks ago and saving me from an accident. Thank you Ma, Thank you Jesus.`,
  },

  {
    username: "Faith O",
    subtitle: "Healing From a Mysterious Lump",
    desc: `I felt something like a hard lump in my female area. I did not want to name it, so I just assumed and prayed it away. Then I asked the Lord for wisdom to make it go away, and He provided it to me. As of the time this fast began until now, it has drastically decreased and is almost no more.
I also want to thank Minister Chantal for your many contributions and prophetic words. They often help me out of many situations. God bless you, your family, and your ministry.`,
  },

  {
    username: "Tlotliso Mekgoe",
    subtitle: "Freedom From 19 Years of Spiritual Bondage",
    desc: `My name is Tlotliso Mekgoe from Johannesburg, South Africa. I had been dying spiritually, or even dead— in bondage to a pornography addiction that has lasted for the last 18 to 19 years. I am a pastor's son, and I grew up knowing the Lord.
But in early September this year, I think I had a strange dream, or something happened while I was awake, and in my curiosity I searched for an answer to what had been going on in my life. When I woke up and began searching on Google, I came across a video of Chantal Ekabe Ministries on YouTube and watched the video, which blessed me. Then I got hooked when I heard the prophecy to pray for CKirk. After that, I watched occasionally, but since then I have been watching daily, and my prayer life has significantly intensified.
Yesterday, the 9th of October, I received a word of prophecy about someone born in 1992, and I believe that is me. Today, the 10th of October, I received a prophecy about mathematics, and I believe it is about me because I have written and tried to upgrade my matric exams in order to get tertiary education. This has been happening since 2011, and in South Africa you need a matric or grade 12 certificate to even get a decent job, but to no avail.
However, after today’s prophecy, I believe I will do well, since I am writing my matric exams in exactly three weeks’ time. By the grace of God, I will do well. I have been fasting as well, and I am hearing from God and growing steadily in my spiritual walk with Him.
Thank you very much. May God richly bless you, woman of God.`,
  },

  {
    username: "Anna Alladin",
    subtitle: "Deliverance From Workplace Warfare",
    desc: `Good morning Minister Chantal, I would love to share a testimony on today’s ministration. When you mentioned that there’s someone going through battles, I immediately knew this was for me. I have been going through intense warfare in my office where everyone is against me.
Today, I was served papers for a disciplinary hearing, which seems like they want to fire me. As much as I was shocked and felt betrayed, I am also weary of fighting and defending myself. Thank you for all the prayers, and I believe God for wisdom to navigate through this case.
Thank you so much!`,
  },

  {
    username: "Xitsundzuxo Mthunzi O",
    subtitle:
      "Family Deliverance, Safe Childbirth & Victory Over Spiritual Resistance",
    desc: `Greetings Minister Chantal, I’d like to thank God. A few days before the 18th of September, you mentioned that someone would deliver well. My sister, who had 3 miscarriages, was in the theater on the 18th of September, and the doctor said they had to do a C-section because her situation was critical. But glory to God, everything went well, and now the baby is even out of the incubator.
Even though the medical aid was refusing to pay their bills, glory to God everything is being sorted out. And also, she’s not allowed to breastfeed because her milk is affected. I believe the Lord is in control of this situation too.
And another testimony: the witches who are attacking me and my younger sister—preventing us from getting jobs or even moving out of home—swept the yard on the 1st of October 2025. They usually do the sweeping when something is about to happen in our lives, and they also burn incense.
During prayer on the 2nd of October 2025, while we were praying against “Resistance,” towards the end of the prayer a brown lizard came out of my left foot, after I had been experiencing swelling on the 1st of October 2025.
Glory be to God for the deliverance, and I thank you for your obedience to serve the Lord and for continually praying with us and for us. May God protect and bless you and your family abundantly. I believe there are more testimonies coming from us, Amen!!!`,
  },

  {
    username: "Barbara Newton",
    subtitle: "Miracle Healing From a Life-Threatening Brain Tumor",
    desc: `Hello Minister Chantal, blessings to you and your ministry. I want to start out by saying all glory to God! God has performed a miracle in the life of my children's father, Kevin. For months, Kevin was complaining of his vision being blurry, and all he could see was black in his eyes. He was also suffering with extreme headaches, and within the last two months the family noticed he was experiencing memory loss. Although all of this was going on, I encouraged him to be seen by a doctor, but he refused.
Finally, I went online and made him an appointment to be seen by the doctor, and I included all of the symptoms he was having. Kevin's doctor’s appointment was set for September 30th. On Thursday, September 25th, Kevin received a call from the doctor's office going over the request and the symptoms he was having, and they provided him with an even sooner appointment for Friday, September 26th, to be seen. Then the same nurse called back and suggested he should go into the ER that day because she was concerned about him possibly experiencing a stroke.
I took him directly to the ER that day, and when he was seen, they checked his vision and then he was given a CT scan of his head. When the doctor came into the room, he spoke something we were not expecting. The doctor stated that Kevin had a large tumor in his brain that was bleeding excessively, and the tumor was pressing on his eye, causing his vision to go. Because of the tumor, he had lost 75% of his vision, which is considered legally blind. He was in need of surgery to remove the tumor. This news was devastating to hear.
He was admitted into the hospital and was scheduled to have surgery on October 1st. Before surgery, he met with the surgeon, where he was faced with even more discouraging news. The surgeon, Dr. Mendez, who is one of the top surgeons in the country and has done thousands of surgeries, was very concerned about this surgery due to the size of the tumor, which was continually growing. If the tumor was not removed, he would die.
The concerns were that because the tumor was causing so much pressure on the eye, there was a chance that after surgery he would be blind. There were also concerns about the membrane of the brain and a few other complications. The surgeon said this was a difficult case.
On October 1st, he had his surgery — and God came through. After the surgery, Dr. Mendez stated it was a success. His vision is intact, and they have removed all of the tumor.
I give all glory to GOD!`,
  },

  {
    username: "Bryanna S. Evans",
    subtitle: "Restoration of Love and Fulfillment of Prophecy in September",
    desc: `Shalom to you, Minister Chantal. I have to submit this testimony before we leave the month of September. I watch your channel almost every broadcast and have for the last 3 years. I have also done my very best to fast every month with you and the PPP family, with the Lord's help.
On the last day of the 3-day fast this month of September, you said someone is believing God for the fruit of the womb and that someone is longing for a person who is missing in their life. You said, “God will make a way for you in this season. God will bless you and bring this person back into your life.”
Well, not even 4 days later, the Holy Spirit showed me in a dream my person and led me to reconnect with him in the physical the very next day after showing he and I reconciling and reconnecting in that dream. He had just moved back to my state that week. I almost hesitated getting up and going out of my home that day for fear of being deceived, but God is not a man that He should lie!
I met my person in the winter of 2023, and he returned to where he lived 16 hours away and asked me if I would wait for him. I agreed to wait because I felt in my heart that God brought us together, but as the wait became longer and longer, I grew more and more weary. After 1 year and 9 months, I had just prayed to the Lord recently that I was ready to give up on love again and remain single for His glory.
You continue to pray with us everyday, and that word really spoke to me, and I cried out to the Father that I wanted to receive that prophecy for myself. I praise God that He brought it to pass—our reconnection story.
This is my prayer: that this is the beginning of our testimony and that God will settle us in marriage and with the fruit of the womb by His grace. Thank you for letting the Spirit of God speak to you, Chantal. God bless your marriage and family too.`,
  },

  {
    username: "Joanne TL",
    subtitle: "Instant healing from pain after a word of knowledge",
    desc: `On September 20, 2025 during the live prayer, my sister Chantal said “someone has pain on their side, God is healing that pain." I agreed with the word, because I woke that morning with pain on my side. I testify that I am healed from that exact day. Thank you God for using my sister Chantal to declare my healing!! Amen`,
  },

  {
    username: "Grace Owusu Ampofo",
    subtitle: "Restoration Confirmed Through Prophecy",
    desc: `Dear Minister Chantal,
I am filled with great joy to testify on this great altar. First of all, the PPP Altar has helped me to grow spiritually. Almost every day when I connect, God speaks to my family through you, and I want to thank God for that and also bless you, Chantal, for availing yourself to be used by God.
Now to my main testimony: I want to thank God for a word of knowledge that came in the 2nd week of September about my husband Evans. You said, “I see a name, Evans, who is picking up things in the spirit, and it stands for recovery. God is restoring all that you have lost.” And I said AMEN. My husband's name is Evans, and I believe God has done it for us as a family, considering the recent happenings in our home.
I am here to say a big thank you to God — the God who sees me and who has done it for us as a family.
God bless you, Minister Chantal. May the oil on your head never run dry. More grace, and may God bless your family.`,
  },

  {
    username: "Rirhandzu",
    subtitle: "Family Deliverance and Impossible Financial Breakthrough",
    desc: `Good day, my PPP Family. I would like to give glory to the Lord God Almighty for His mighty works that are manifesting in my life. I was born into a family that was bound by witchcraft, limitations, untimely death, and curses—the list is endless.
I came across this platform one day while browsing through YouTube, and I started praying with you last year March. You have taught me warfare, and I’m winning the battle through deliverance from the prayers.
While praying in August, you mentioned that someone would receive funds. Indeed, that word was for my mother. She was waiting for a payout from a claim. Though it was impossible for the insurance company to pay, through prayers it became possible.
God bless you and your family, Minister Chantal. Thank you.`,
  },

  {
    username: "A S",
    subtitle: "Protection, Vindication, and Deliverance From Wicked Attacks",
    desc: `Glory be to God for the things He has done. Greetings. I received a word from your Live about a witch leaving us alone, and immediately I saw in my mind a particular woman who assaulted my significant other as her young children watched, hitting me in the process because we did not let her on our property to visit a person who was being evicted.
Although she apologized, she later came to my husband and confessed that she should have done worse. Thank God, after I received this word, I have not seen her since.
As I testified about and read on July 18th, the person she was coming to visit — whose most recent erroneous case was also dismissed — has also seen a turnaround as I continue to pray along on the Live. We pray this person leaves expediently because of the recent arrest for assaulting my husband after the police refused to make an arrest prior.
God does not desire any to perish but to repent; however, I believe this person may be given over to a reprobate mind, and the wicked should not get what they want. I continue to pray for the peace and safety of our home and that God vindicates and helps us, even yet still, for repentance.`,
  },

  {
    username: "PPP Family Member",
    subtitle: "Obedience to a Prophetic Instruction Opened a Door",
    desc: `Good morning Ma Chantal, I want to testify to the glory of God. During the Monday prayer session, I received an instruction to take a prophetic step. After the session, I lost my peace until I obeyed, and it came out well, and the hand of God was on it.
Thank you, Ma, for all you do for us, the PPP Family. I would have missed an opportunity if that word didn’t come.
May God bless you beyond your imagination and grant you your heart desires. We love you.`,
  },
];

const Testimonials: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [selected, setSelected] = useState<null | TestimonyItem>(null);
  const [published, setPublished] = useState<TestimonyItem[]>([]);

  // GET /testimonies returns only published testimonies
  useEffect(() => {
    let active = true;
    axiosInstance.get<any[]>("/testimonies")
      .then(({ data }) => {
        if (!active || !Array.isArray(data)) return;
        setPublished(
          data
            .filter((t) => t?.body)
            .map((t) => ({ username: t.full_name ?? "", subtitle: t.title ?? "", desc: t.body }))
        );
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const testimonials = [...published, ...staticTestimonials];

  const handleReadFull = (item: TestimonyItem) => {
    setSelected(item);
    setModalOpen(true);
  };

  return (
    <motion.section
      className="testimonials-outer-section"
      variants={staggerContainer(0.2, 0.3)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      <motion.h2
        className="ministry-title testimony-title"
        variants={fadeIn("up", "spring", 0.1, 0.8)}
      >
        Testimonies
      </motion.h2>

      <motion.section
        className="testimonials-container"
        variants={fadeIn("up", "spring", 0.1, 1.5)}
      >
        <HorizontalScroll
          showArrows={true}
          showArrowsOnDesktop
          showIndicator={false}
          autoScroll
        >
          {testimonials.map((item, idx) => (
            <TestimonyCard
              key={idx}
              username={item.username}
              subtitle={item.subtitle}
              desc={item.desc}
              onReadFull={() => handleReadFull(item)}
            />
          ))}
        </HorizontalScroll>
      </motion.section>

      <motion.p
        className="test-desc"
        variants={fadeIn("up", "spring", 0.5, 1.6)}
      >
        Has God done Something for you through this Ministry? Like that one
        leper, Don't keep it back, share it now to help boost other people's
        faith.
      </motion.p>

      <motion.div
        variants={fadeIn("up", "spring", 0.6, 0.8)}
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <ButtonThree
          text="Submit Your Testimony"
          bgColor="black"
          color="#fff"
          borderRadius="30px"
          width="30%"
          onClick={() => navigate("/testimony")}
        />
      </motion.div>

      <TestimonyModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        username={selected?.username || ""}
        subtitle={selected?.subtitle || ""}
        desc={selected?.desc || ""}
      />
    </motion.section>
  );
};

export default Testimonials;
